import textButton from "../assets/sidepanel/text-button.png";
import media from "../assets/sidepanel/media.png";
import list from "../assets/sidepanel/list.png";
import catelog from "../assets/sidepanel/catelog.png";
import cart from "../assets/sidepanel/cart.png";
import multiCart from "../assets/sidepanel/multi-cart.png";
import thunder from "../assets/sidepanel/thunder.png";
import address from "../assets/sidepanel/address.png";
import code from "../assets/sidepanel/code.png";
import connectFlow from "../assets/sidepanel/connect-flow.png";
import conversionAPI from "../assets/sidepanel/conversion-api.png";
import interventation from "../assets/sidepanel/interventation.png";
import location from "../assets/sidepanel/location.png";
import maths from "../assets/sidepanel/maths.png";
import googleSheets from "../assets/sidepanel/google-sheets.png";
import playlist from "../assets/sidepanel/playlist.png";
import question from "../assets/sidepanel/question.png";
import tag from "../assets/sidepanel/tag.png";

import SidePanel from "../models/types";

export type SidepanelSections = Record<string, SidePanel[]>;

const SIDEPANEL: SidepanelSections = {
    "Message Type": [
        {
            id: "",
            type: "TEXT_BUTTON",
            name: "Text Buttons",
            icon: textButton,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "MEDIA_BUTTON",
            name: "Media Buttons",
            icon: media,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "LIST",
            name: "List",
            icon: list,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "CATELOGUE_MESSAGE",
            name: "Catelogue Message",
            icon: catelog,
            enabled: false,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "SINGLE_PRODUCT",
            name: "Single Product",
            icon: cart,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "MULTI_PRODUCT",
            name: "Option List",
            icon: multiCart,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "PRODUCT_LIST",
            name: "Product List",
            icon: multiCart,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "TEMPLATE",
            name: "Template",
            icon: thunder,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "CAROUSEL",
            name: "Carousel",
            icon: playlist,
            enabled: true,
            canAddContent: true,
            backLinkEnabled: true
        }
    ],
    "Action": [
        {
            id: "",
            type: "INTERVENTION",
            name: "Request Interventaion",
            icon: interventation,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "CONVERSION",
            name: "Meta Conversions API",
            icon: conversionAPI,
            enabled: false,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "CONDITION",
            name: "Condition",
            icon: code,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "FLOW",
            name: "Connection Flow",
            icon: connectFlow,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "ADDRESS",
            name: "Ask Address",
            icon: address,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "LOCATION",
            name: "Ask Location",
            icon: location,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "QUESTION",
            name: "Ask Question",
            icon: question,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "MEDIA",
            name: "Ask Media",
            icon: media,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "ATTRIBUTE",
            name: "Set Attribute",
            icon: playlist,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "ADD_TAG",
            name: "Add Tag",
            icon: tag,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "API_REQUEST",
            name: "API Request",
            icon: conversionAPI,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "SMART_DELAY",
            name: "Smart Delay",
            icon: maths,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        },
        {
            id: "",
            type: "GOOGLE_SHEETS",
            name: "Google Sheets",
            icon: googleSheets,
            enabled: true,
            canAddContent: false,
            backLinkEnabled: true
        }
    ],

}
export default SIDEPANEL;